<app-header></app-header>
<section class="bredcrumb">
  <div class="container">
    <ul class="brd-nav">
      <li><a [routerLink]="['/']"> Home </a></li>
      <li> View Profile</li>
    </ul>
  </div>
</section>
<!--- End of bredcrumb -->

<section class="single-page doctors-detail user-profile-view padd-row">
  <div class="container">
    <form #f="ngForm" class="doctors-edit-main">
      <div class="row">
        <div class="col-lg-4">
          <div class="doc-detail-lft p-0 sidebar">

            <div style="cursor:pointer" (click)="showImage(loginData.profilePicture)"
                 class="user-profile-view-left-img doc-detail-box grey-bg mb-4">
              <img [src]="loginData.profilePicture" alt="image">
            </div>
            <div class="doctor-box-top-cnt">
              <input style="display:none;" (change)="fileChanged($event)" type="file" accept="image/*" #file>
              <button type="button" id="buttonfileupload" class="upload-img" (click)="file.click()"> Upload or change
                your profile image here
              </button>
            </div>

            <div class="user-profile-view-left-list doc-detail-box grey-bg p-25-side mb-4">
              <ul *ngIf="!isDisable">
                <li>
                  <img src="assets/images/form-user.png" alt="image">

                  <label> Name </label>
                  <input type="text" required [disabled]="isDisable" name="userName" #userName="ngModel"
                         [(ngModel)]="loginData.name" class="form-control" placeholder="Enter Name">
                  <div *ngIf="f.submitted && !userName.valid && !isDisable" class="alert alert-danger">Name is
                    required
                  </div>

                </li>
                <li>
                  <img src="assets/images/phone.png" alt="image">
                  <label> Phone No </label>
                  <input type="text" required name="userPhone" [disabled]="isDisable"
                         (keypress)="numberOnly($event,null)" #userPhone="ngModel" [(ngModel)]="loginData.phoneNo"
                         class="form-control" placeholder="Enter Phone No">
                  <div *ngIf="f.submitted && !userPhone.valid && !isDisable" class="alert alert-danger">Phone is
                    required
                  </div>
                </li>
                <li>
                  <img src="assets/images/email.jpg" alt="image">
                  <label> Email </label>
                  <input type="text" name="userEmail" [disabled]="isDisable" #userEmail="ngModel"
                         [(ngModel)]="loginData.email" class="form-control" placeholder="Enter Email Id">
                  <!-- <div *ngIf="f.submitted && !userEmail.valid && !isDisable" class="alert alert-danger" >Email is required</div> -->
                </li>
                <li>
                  <i class="fa fa-key" aria-hidden="true" style="color: #4fb6e8;
                  font-size: 23px;margin-right: 22px;"></i>


                  <label> Password </label>
                  <input [type]="showEye ? 'password' : 'text'" name="userPassword" [disabled]="isDisable"
                         #userPassword="ngModel" [(ngModel)]="loginData.password" class="form-control"
                         placeholder="Enter Password">
                  <span [class]="showEye ? 'fa fa-fw fa-eye' : 'fa fa-fw fa-eye-slash'"
                        (click)="showEye=!showEye"></span>
                  <!-- <div *ngIf="f.submitted && !userEmail.valid && !isDisable" class="alert alert-danger" >Email is required</div> -->
                </li>
              </ul>
              <ul *ngIf="isDisable">
                <li>
                  <img src="assets/images/form-user.png" alt="image"> {{ loginData.name }}
                </li>
                <li>
                  <img src="assets/images/phone.png" alt="image"> {{ loginData.phoneNo }}
                </li>
                <li>
                  <img src="assets/images/email.jpg" alt="image"> {{ loginData.email }}
                </li>
                <li>

                  <i class="fa fa-key" aria-hidden="true" style="color: #4fb6e8;
    font-size: 23px;margin-right: 22px;"></i>Password...
<!--                                    <img src="assets/images/email.jpg" alt="image"> -->
                </li>
              </ul>
            </div>

            <div class="set-reminder-user doc-detail-box grey-bg p-25-side mb-4">
              <h3> Reminder </h3>
              <form #rf="ngForm" (ngSubmit)="setReminder(rf)">
                <div class="row">
                  <div class="col-md-12">
                    <label> Name: </label>
                    <div class="form-group-img">
                      <input type="text" #reminderName="ngModel" required name="reminderName"
                             [(ngModel)]="reminder.name" class="form-control" placeholder="Name...">
                      <!-- <i class="fa fa-chevron-down" aria-hidden="true"></i> -->
                      <!-- <div *ngIf="rf.submitted && !reminderName.valid" class="alert alert-danger" >Name is required</div> -->
                    </div>
                  </div>
                  <div class="col-md-12">
                    <label> Type: </label>
                    <div class="form-group-img">
                      <select required name="reminderType" #reminderType="ngModel" [(ngModel)]="reminder.type"
                              class="form-control">
                        <option value="NORMAL">Normal</option>
                        <option value="URGENT">Urgent</option>
                      </select>
                      <!-- <i class="fa fa-chevron-down" aria-hidden="true"></i> -->
                      <!-- <div *ngIf="rf.submitted && !reminderType.valid" class="alert alert-danger" >Type is required</div> -->
                    </div>
                  </div>
                  <div class="col-md-12">
                    <label> Date: </label>
                    <div class="form-group-img checked-val">
                      <input required class="form-control "
                             placeholder="Select Date..."
                             bsDatepicker
                             #dp="bsDatepicker"
                             name="reminderDate"
                             #reminderDate="ngModel"
                             [(ngModel)]="reminder.date"
                             [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' }"
                             [(bsValue)]="reminder.date"
                             [minDate]="minDateValue"
                      >

                      <i class="fa fa-calendar-check-o" aria-hidden="true"></i>
                      <!-- <div *ngIf="rf.submitted && !reminderDate.valid" class="alert alert-danger" >Date is required</div> -->
                    </div>
                  </div>
                  <!-- <div class="col-md-12">
                        <label> End Date: </label>
                        <div class="form-group-img">
                              <input class="form-control"
                             placeholder="Select Date..."



                             bsDatepicker
                             #dp="bsDatepicker"
                             name="reminderEndTime" [(ngModel)]="reminder.endDate"
                             [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' }"
                             [(bsValue)]="reminder.endDate"
                            >

                            <i class="fa fa-calendar-check-o" aria-hidden="true"></i>
                        </div>
                    </div> -->
                  <div class="col-md-12">
                    <label> Time: </label>
                    <div class="form-group-img">
                      <input class="form-control" required (click)="open()" #reminderTime="ngModel" name="reminderTime"
                             [value]="reminder.time" [(ngModel)]="reminder.time"/>
                      <!-- <button (click)="open()">Time</button> -->
                      <!-- <input type="text" class="form-control" placeholder="21:10 PM">-->
                      <i class="fa fa-clock-o" aria-hidden="true"></i>
                      <!-- <div *ngIf="rf.submitted && !reminderTime.valid" class="alert alert-danger" >Time is required</div> -->
                    </div>
                  </div>
                  <div class="col-md-12">
                    <input type="submit" class="btn-style" value="Set Reminder">
                    <input type="button" class="btn-style mt-3 btn-style-border" data-toggle="modal"
                           data-target="#reminderListModal" value="List Reminder">
                  </div>
                </div>
              </form>
            </div>


          </div>
        </div>

        <div class="col-lg-8">
          <div class="white-bg-shadow doc-chat-right-side">

            <div class="doc-chat-header-edit-btn">
              <button type="buton" *ngIf="isDisable" class="btn-style btn-style-grey" (click)="editProfile()"
                      class="btn btn-primary btn-style"> Edit Profile
              </button>
              <!-- <button type="submit" *ngIf="!isDisable" (click)="updateProfile(f)"  class="btn btn-primary btn-style"> Submit Profile </button> -->
            </div>
            <div class="doc-chat-header">
              <h3> About {{ loginData.name }} </h3>
            </div>
            <div class="user-profile-right">
              <div *ngIf="!isDisable" class="doc-detail-cnt btm-line">
                <input type="text" [disabled]="isDisable" name="userAbout" #userAbout="ngModel"
                       [(ngModel)]="loginData.about" class="form-control" placeholder="Enter About...">
                <!-- <div *ngIf="f.submitted && !userAbout.valid && !isDisable" class="alert alert-danger" >About  is required</div> -->
              </div>
              <div *ngIf="isDisable" class="doc-detail-cnt btm-line">
                <p class="mb-0">{{ loginData.about }}</p>
              </div>
              <div *ngIf="!isDisable" class="doc-detail-edu doc-detail-cnt btm-line">
                <h3> Education & Credentials </h3>
                <h4> Education </h4>
                <tag-input [disable]="isDisable" name="userEducation" #userEducation="ngModel"
                           [secondaryPlaceholder]="['Eduation...']" [modelAsStrings]=[true]
                           [(ngModel)]="loginData.education" [inputClass]="['form-control']"></tag-input>
                <!-- <div *ngIf="f.submitted && !userEducation.valid && !isDisable" class="alert alert-danger" >Education  is required</div> -->
                <h4> Languages Spoken </h4>
                <tag-input [disable]="isDisable" name="userLanguage" #userLanguage="ngModel"
                           [secondaryPlaceholder]="['Languages...']" [modelAsStrings]=[true]
                           [(ngModel)]="loginData.languages" [inputClass]="['form-control']"></tag-input>
                <!-- <div *ngIf="f.submitted && !userLanguage.valid && !isDisable" class="alert alert-danger" >Language  is required</div> -->
              </div>
              <div *ngIf="isDisable" class="doc-detail-edu doc-detail-cnt btm-line">
                <h3> Education & Credentials </h3>
                <h4> Education </h4>
                <p *ngFor="let edu of loginData.education"> {{ edu }} </p>
                <!-- <p class="mb-4"> Lutheran Medical Center (Residency) </p> -->
                <h4> Languages Spoken </h4>
                <p class="mb-0"> {{ loginData?.languages?.join(' , ') }} </p>
              </div>
              <div *ngIf="!isDisable" class="doc-detail-edu doc-detail-cnt btm-line">
                <h3> Contact Information </h3>
                <div class="row no-gutters">
                  <div class="col-md-6">
                    <p class="mb-0 "><strong> Gender: </strong>
                      <span class="radio">
                        <label>
                                    Male<input [disabled]="isDisable" type="radio" [(ngModel)]="loginData.gender" class="check-box-margin"
                                               name="gender" value="Male">
                          </label>
                                      </span>
                      <span class="radio">
                        <label>
                                    Female<input [disabled]="isDisable" type="radio" [(ngModel)]="loginData.gender" class="check-box-margin"
                                                 name="gender" value="Female">
                          </label>
                                    </span>

                    </p>

                  </div>
                  <div class="col-md-6">
                    <!-- <p class="mb-0"> -->
                    <strong> Date of Birth: </strong>
                    <input class="form-control"
                           placeholder="Select Date of Birth..."
                           [(ngModel)]="loginData.dob"
                           [disabled]="isDisable"
                           name="datebook"
                           bsDatepicker
                           #dp="bsDatepicker"

                           [bsConfig]="{ dateInputFormat: 'MMMM Do YYYY' }"
                           [(bsValue)]="loginData.dob"
                    >
                    <!-- <input type="text" [disabled]="isDisable" required name="userDob" #userDob="ngModel" [(ngModel)]="loginData.dob" class="form-control" placeholder="Enter Date of Birth..."> -->
                    <!-- <div *ngIf="f.submitted && !userDob.valid && !isDisable" class="alert alert-danger" >Date of Birth  is required</div> -->
                    <!-- </p> -->
                  </div>
                  <div class="col-md-6 mb-0">
                    <!-- <p class="mb-0"> -->
                    <strong> Blood Group: </strong>
                    <select name="userBlood" [disabled]="isDisable" #userBlood="ngModel"
                            [(ngModel)]="loginData.bloodGroup" class="form-control">
                      <option value="A+">A+</option>
                      <option value="A-">A-</option>
                      <option value="B+">B+</option>
                      <option value="B-">B-</option>
                      <option value="O+">O+</option>
                      <option value="AB+">AB+</option>
                      <option value="AB-">AB-</option>
                    </select>
                    <!-- <div *ngIf="f.submitted && !userBlood.valid && !isDisable" class="alert alert-danger" >Please select Blood Group</div> -->
                    <!-- </p> -->
                  </div>
                </div>
              </div>

              <div *ngIf="isDisable" class="doc-detail-edu doc-detail-cnt btm-line">
                <h3> Contact Information </h3>
                <div class="row no-gutters">
                  <div class="col-md-6">
                    <p class="mb-0"><strong> Gender: </strong> {{ loginData.gender }} </p>
                  </div>
                  <div class="col-md-6">
                    <p class="mb-0"><strong> Date of Birth: </strong> {{ loginData.dob }} </p>
                  </div>
                  <div class="col-md-6 mb-0">
                    <p class="mb-0"><strong> Blood Group: </strong> {{ loginData.bloodGroup }} </p>
                  </div>
                </div>
              </div>
              <div *ngIf="!isDisable" class="doc-detail-edu doc-detail-cnt btm-line">
                <h3> Address </h3>
                <div class="row no-gutters">
                  <div class="col-md-12">
                    <!-- <p class="mb-0"> -->
                    <strong> Street Name/ Area: </strong>
                    <input type="text" [options]='options' (onAddressChange)="handleAddressChange($event)"
                           ngx-google-places-autocomplete #placesRef="ngx-places" name="userAddress"
                           #userAddress="ngModel" [(ngModel)]="loginData.address" class="form-control"
                           placeholder="Enter Your Address">
                    <!-- <input type="text" [disabled]="isDisable" required name="userAddress" #userAddress="ngModel" [(ngModel)]="loginData.address" class="form-control" placeholder="Enter Address..."> -->
                    <!-- <div *ngIf="f.submitted && !userAddress.valid && !isDisable" class="alert alert-danger" >Enter Address</div> -->
                    <!-- </p> -->
                  </div>
                  <!-- <div class="col-md-12">

                            <strong> House No: </strong>
                            <input type="text" [disabled]="isDisable" required name="userHouseNo" #userHouseNo="ngModel" [(ngModel)]="loginData.houseNo" class="form-control" placeholder="Enter House No...">
                            <div *ngIf="f.submitted && !userHouseNo.valid" class="alert alert-danger" >Enter House No</div>

                    </div> -->
                  <div class="col-md-6">
                    <!-- <p class="mb-0">  -->
                    <strong> City: </strong>
                    <input type="text" [disabled]="isDisable" name="userCity" #userCity="ngModel"
                           [(ngModel)]="loginData.city" class="form-control" placeholder="Enter City...">
                    <!-- <div *ngIf="f.submitted && !userCity.valid && !isDisable" class="alert alert-danger" >Enter City</div> -->
                    <!-- </p> -->
                  </div>
                  <div class="col-md-6">
                    <!-- <p class="mb-0">  -->
                    <strong> State: </strong>
                    <input type="text" [disabled]="isDisable" name="userState" #userState="ngModel"
                           [(ngModel)]="loginData.state" class="form-control" placeholder="Enter State...">
                    <!-- <div *ngIf="f.submitted && !userState.valid && !isDisable" class="alert alert-danger" >Enter State</div> -->
                    <!-- </p> -->
                  </div>
                  <div class="col-md-6 mb-0">
                    <!-- <p class="mb-0"> -->
                    <strong> Country: </strong>
                    <input type="text" [disabled]="isDisable" name="userCountry" #userCountry="ngModel"
                           [(ngModel)]="loginData.country" class="form-control" placeholder="Enter Country...">
                    <!-- <div *ngIf="f.submitted && !userCountry.valid && !isDisable" class="alert alert-danger" >Enter Country</div> -->
                    <!-- </p> -->
                  </div>
                  <div class="col-md-6 mb-0">
                    <!-- <p class="mb-0"> -->
                    <strong> Pincode: </strong>
                    <input type="text" [disabled]="isDisable" (keypress)="numberOnly($event,null)" name="userPin"
                           #userPin="ngModel" [(ngModel)]="loginData.pincode" class="form-control"
                           placeholder="Enter Pin Code...">
                    <!-- <div *ngIf="f.submitted && !userPin.valid && !isDisable" class="alert alert-danger" >Enter Pin Code</div> -->
                    <!-- </p> -->
                  </div>
                </div>
              </div>
              <div *ngIf="isDisable" class="doc-detail-edu doc-detail-cnt btm-line">
                <h3> Address </h3>
                <div class="row no-gutters">
                  <div class="col-md-12">
                    <p class="mb-0"><strong> House No. Street Name/ Area: </strong> {{ loginData.address }} </p>
                  </div>
                  <div class="col-md-6">
                    <p class="mb-0"><strong> City: </strong> {{ loginData.city }} </p>
                  </div>
                  <div class="col-md-6">
                    <p class="mb-0"><strong> State: </strong> {{ loginData.state }} </p>
                  </div>
                  <div class="col-md-6 mb-0">
                    <p class="mb-0"><strong> Country: </strong> {{ loginData.country }} </p>
                  </div>
                  <div class="col-md-6 mb-0">
                    <p class="mb-0"><strong> Pincode: </strong> {{ loginData.pincode }} </p>
                  </div>
                </div>
              </div>
              <!-- <div class="upload-list-pharmacy doc-detail-cnt">
                  <h3> Upload List </h3>
                  <div class="row">
                      <div class="col-md-6">
                          <div class="upload-list-lft">
                              <input type="file" name="img" multiple>
                              <img src="assets/images/upload-file.png" alt="image">
                              <h3> Drag & drop </h3>
                              <h4> or <span> Browse </span> your files </h4>
                          </div>
                      </div>
                      <div class="col-md-6">
                          <div class="upload-list-rght">
                              <div class="upload-list-files">
                                  <ul>
                                      <li>
                                          <div class="upload-list-file-box">
                                              <img src="assets/images/file.png" alt="image">
                                              <h4 class="clearfix"> Medicine List 1 <i class="fa fa-times" aria-hidden="true"></i> </h4>
                                              <p> 12 Mb </p>
                                              <div class="progress">
                                                  <div class="progress-bar" style="width:70%"></div>
                                              </div>
                                          </div>
                                      </li>
                                      <li>
                                          <div class="upload-list-file-box">
                                              <img src="assets/images/file.png" alt="image">
                                              <h4 class="clearfix"> Medicine List 2 <i class="fa fa-times" aria-hidden="true"></i> </h4>
                                              <p> 12 Mb </p>
                                              <div class="progress">
                                                  <div class="progress-bar" style="width:40%"></div>
                                              </div>
                                          </div>
                                      </li>
                                  </ul>
                              </div>
                              <div class="upload-list-btm-btns text-right">
                                  <a href="javascript://" class="btn-style btn-style-border"> Cancel </a>
                                  <a href="javascript://" class="btn-style"> Upload </a>
                              </div>
                          </div>
                      </div>
                  </div>
              </div> -->
              <div class="doc-chat-ftr-btn">
                <button type="buton" *ngIf="isDisable" class="btn-style btn-style-grey" (click)="editProfile()"
                        class="btn btn-primary btn-style"> Edit Profile
                </button>
                <button type="submit" *ngIf="!isDisable" (click)="updateProfile(f)" class="btn btn-primary btn-style">
                  Submit Profile
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </form>
  </div>
</section>
<!-- End of doctors-detail -->


<input type="hidden" id="orderImagesCLick" data-toggle="modal" data-target="#orderImagesModal">

<!-- The Modal -->
<div class="modal fade" id="orderImagesModal">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Profile Image</h5>
      </div>
      <!-- Modal body -->
      <div class="modal-body text-center">
        <slideshow
          [minHeight]="'525px'"
          [showArrows]="false"
          [imageUrls]="imageUrlArray"></slideshow>
        <button class="btn btn-primary" style="margin-top: 20px;"
                data-toggle="modal" data-target="#orderImagesModal">OK
        </button>

      </div>
    </div>
  </div>
</div>


<input type="hidden" id="remnderListClick" data-toggle="modal" data-target="#reminderListModal">

<!-- The Modal -->
<div class="modal fade" id="reminderListModal">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Reminders</h5>
      </div>
      <!-- Modal body -->
      <div class="modal-body text-center">

        <div class="set-reminder-user-details-btm doc-detail-box ">
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
              <tr>
                <td>Name</td>
                <td>Type</td>
                <td>Date</td>
                <td>Time</td>
                <td>Delete</td>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let reminder of reminders">
                <td>{{ reminder.name }}</td>
                <td>{{ reminder.type}}</td>
                <td>{{ reminder.date | date:'dd-MM-yyyy' }}</td>
                <td>{{ reminder.time | date:'h:mm aa' }}</td>
                <td><i (click)="deleteReminder(reminder._id)" class="fa fa-trash" aria-hidden="true"></i></td>

              </tr>
              </tbody>
            </table>
          </div>

        </div>

      </div>
    </div>
  </div>
</div>
